export default {
  ui: {},

  init() {
    // JavaScript to be fired on all pages
    this.bindUI();
    this.bindEvents();
  },

  bindUI() {
		this.ui.html        = document.querySelector('html');
    this.ui.toggle      = document.querySelector('.js-nav-toggle');
    this.ui.navPrimary  = document.querySelector('.nav-primary');
    this.ui.navPrimaryItems  = this.ui.navPrimary.querySelectorAll('a');
    this.ui.down        = document.querySelectorAll('.smoothscroll');
  },
  
  bindEvents() {
		// Open / Close Menu Mobile.
    this.ui.toggle.addEventListener('click', this.toggleNav.bind(this));

    // For each link, add event.
		for (let i = 0, j = this.ui.navPrimaryItems.length; i < j; i++) {
			this.ui.navPrimaryItems[i].addEventListener('click', this.closeNav.bind(this));
    }
    
    // For each link, add event.
		for (let i = 0, j = this.ui.down.length; i < j; i++) {
			this.ui.down[i].addEventListener('click', this.smoothScroll.bind(this));
    }
	},

	toggleNav() {
		this.ui.html.classList.toggle('nav-open');
  },
  
  closeNav() {
		this.ui.html.classList.remove('nav-open');
  },
  
  smoothScroll(e) {
    // Prevent default.
    e.preventDefault();
    
    const el = e.target;

		// Get item.
    const item = el.closest('a');

    let sectionTo = item.getAttribute('href');
    $('html, body').animate({
      scrollTop: $(sectionTo).offset().top,
    }, 500);
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/util/header.js